export enum Vehicle {
  FOOT = 'FOOT',
  BICYCLE = 'BICYCLE',
  CAR = 'CAR',
  MOTORCYCLE = 'MOTORCYCLE'
}
